import { render } from "./company_detail.vue?vue&type=template&id=aa732862&scoped=true"
import script from "./company_detail.vue?vue&type=script&lang=js"
export * from "./company_detail.vue?vue&type=script&lang=js"

import "./company_detail.vue?vue&type=style&index=0&id=aa732862&scoped=true&lang=css"

import exportComponent from "C:\\Users\\holo\\work\\git-all-source,\\stress_check_Rebuild\\source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa732862"]])

export default __exports__